<template>
  <div class="input-simples">
    <label class="input-simples-label">{{ titulo }}:</label>
    <treeselect
      v-model="categorias"
      :multiple="true"
      :options="options"
      placeholder="#"
      :load-options="loadOptions"
      :auto-load-root-options="false"
      :always-open="false"
    />
  </div>
</template>

<script>
// import the component
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect/dist/vue-treeselect';
import { assign } from 'lodash';

import { mapActions } from 'vuex';

export default {
  name: 'inputChangeCategorias',
  components: {
    Treeselect,
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: Array,
    },
  },
  data() {
    return {
      categorias: null,
      options: null,
    };
  },
  methods: {
    ...mapActions({
      getCategorias: 'categoria/fetchAll',
    }),
    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        const {
          data: { categorias },
        } = await this.getCategorias();
        const categoriasMap = categorias.data;

        categoriasMap.sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }

          if (a.label > b.label) {
            return 1;
          }

          return 0;
        });

        this.options = categoriasMap;
      }
    },
  },
  watch: {
    categorias: function(newValue) {
      this.$emit('change', newValue);
    },
    value: function(newValue) {
      if (newValue != this.categorias) {
        this.categorias = newValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.input-simples {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-bottom: 10px;

  & /deep/ .input-simples-label {
    color: white;
    font-family: 'OpenSans';
    font-size: 13px;
    font-weight: 600;
    margin-right: 10px;
  }

  & /deep/ .vue-treeselect__input {
    line-height: 1.4;
    min-width: 300px;
    padding: 6px 10px;
    outline: none;
    border-radius: 5px;
    color: $cor_amarelo;
    background: transparent;
    /* border: 1px solid rgba(white, 0.35); */

    &::placeholder {
      color: rgba(white, 0.35) !important;
    }
  }

  & /deep/ .vue-treeselect * {
    outline: none !important;
    box-shadow: none !important;
  }

  & /deep/ .vue-treeselect__control {
    background: transparent;
    border-radius: 5px;
    border: 1px solid rgba(white, 0.35) !important;

    &:hover {
      border: 1px solid rgba(white, 0.35) !important;
    }
  }
  & /deep/ .vue-treeselect__value-container {
    line-height: 1.4;
    padding: 0;
  }
  & /deep/ .vue-treeselect__placeholder {
    font-family: 'OpenSans' !important;
    color: rgba(white, 0.35);
    font-size: 14px;
  }
  & /deep/ .vue-treeselect__multi-value-item {
    color: $cor_amarelo;
    background: transparent;
    border: 1px solid rgba(white, 0.35);
  }
  & /deep/ .vue-treeselect__icon {
    border: 0px;
    color: rgba(white, 0.35);
  }
  & /deep/ .vue-treeselect__multi-value-item:hover > .vue-treeselect__icon {
    color: white;
  }
  & /deep/ .vue-treeselect__x-container {
    color: rgba(white, 0.35);
  }
  & /deep/ .vue-treeselect__x-container:hover {
    color: white;
  }
  & /deep/ .vue-treeselect__control-arrow {
    color: rgba(white, 0.35);
  }
  & /deep/ .vue-treeselect__control-arrow:hover {
    color: white !important;
  }
  & /deep/ .vue-treeselect__control-arrow-container:hover > .vue-treeselect__control-arrow {
    color: white !important;
  }
  & /deep/ .vue-treeselect__menu {
    font-family: 'OpenSans' !important;
    color: $cor_cinza_dark;
    font-size: 14px;
  }
  & /deep/ .vue-treeselect__menu .vue-treeselect__checkbox--checked {
    background: $cor_roxo;
    border-color: $cor_roxo;
  }
  & /deep/ .vue-treeselect__menu .vue-treeselect__option--highlight .vue-treeselect__checkbox {
    border-color: $cor_roxo !important;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .input-simples {
    margin-right: 0px;
    margin-bottom: 10px;

    & label {
      font-size: 12px;
    }

    & input {
      font-size: 12px;
      max-width: calc(85vw - 64px);
      min-width: calc(85vw - 64px);
    }

    & /deep/ .vue-treeselect__placeholder {
      font-family: 'OpenSans' !important;
      color: rgba(white, 0.35);
      font-size: 10px;
    }
    & /deep/ .vue-treeselect__menu {
      font-size: 12px;
    }
    & /deep/ .vue-treeselect__multi-value-item {
      font-size: 12px;
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .input-simples {
    margin-right: 35px;

    & input {
      max-width: 300px;
      min-width: unset;
    }
  }
}
</style>
